/**
 * Volunteer-facing documents shown on /ajudar. Stored in Firebase Storage under
 * the `voluntariado/` prefix (see
 * `patinhas-sem-lar-infra/scripts/migrate-docs/upload-voluntariado.mjs`), using
 * the same public download-token pattern as the transparency archive — plain
 * <a href> targets, no Firebase SDK.
 *
 */

export interface VolunteerDocument {
  id: string;
  title: string;
  /** Short note shown under the card title. */
  description: string;
  url: string;
  sizeBytes: number;
}

export const VOLUNTEER_DOCS: VolunteerDocument[] = [
  {
    id: 'regulamento-abrigo',
    title: 'Regulamento dos Abrigos Canino e Felino',
    description: 'As normas de conduta e segurança no abrigo. Lê antes de te juntares.',
    url: 'https://firebasestorage.googleapis.com/v0/b/key-mystery-450417-k4.firebasestorage.app/o/voluntariado%2Fregulamento-abrigo.pdf?alt=media&token=09484314-d472-4f26-bafb-bdc31b0a0f4a',
    sizeBytes: 299905,
  },
  {
    id: 'ficha-voluntario',
    title: 'Ficha de Inscrição de Voluntário',
    description: 'Preenche, assina e entrega no abrigo para começares.',
    url: 'https://firebasestorage.googleapis.com/v0/b/key-mystery-450417-k4.firebasestorage.app/o/voluntariado%2Fficha-voluntario.pdf?alt=media&token=6e971a15-cb65-42df-b3f4-4ccae2f9185a',
    sizeBytes: 454877,
  },
];
